const types = {
  TEXT: "text",
  DATE: "date",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  SELECT: "select",
  MULTIPLE_SELECT: "multiple_select",
  AREA: "area",
  MATRIX: "matrix",
  LINE: "line",
  REMARK: "remark",
  COMPANY: "company",
  POSTION: "position",
  NAME: "name",
  SEX: "sex",
  PHONE: "phone",
  EMAIL: "email",
  AREADE: "areade",
  BIRTHDAY: "birthday",
  INDUSTRY: "industry",
  EDUCATION: "education",
};

const coms = {
  text: "q-text",
  date: "q-date",
  radio: "q-radio",
  checkbox: "q-checkbox",
  select: "q-select",
  multiple_select: "q-select-multiple",
  area: "q-area",
  matrix: "q-matrix",
  line: "q-line",
  remark: "q-remark",
  company: "q-company",
  position: "q-position",
};

export {types, coms};
